export const getCookies = (): { [key: string]: string } => {
    return Object.fromEntries(
        document.cookie.split(/;\s*/).map(function (cookie: string) {
            const arr = cookie.split('=')
            const key = arr[0]
            const value = arr[1]
            return [key, value]
        })
    )
}